import { Modal } from 'antd';

export const DatasetChangeWarningModal = ({
  visible,
  onOk,
  onCancel,
}: {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}) => {
  return (
    <Modal
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      okButtonProps={{ id: 'DatasetChange-Modal_Ok' }}
      cancelButtonProps={{ id: 'DatasetChange-Modal_Cancel' }}
    >
      <p>
        Changing the dataset will reset your validation and analytics. Continue?
      </p>
    </Modal>
  );
};
